import {requestAction} from 'core/redux/helpers';
import {TAppThunk} from 'core/redux/types';
import {TResponse} from 'core/types';
import {actionSetFeatures} from 'modules/features-toggle/slice';
import {TFeaturesResponse} from 'modules/features-toggle/types';

export const getFeatures: TAppThunk<void> = async (dispatch, _, {featuresToggleService}) => {
    const data = await dispatch(
        requestAction<TResponse<TFeaturesResponse>>({
            requestCb: () => featuresToggleService.getFeatures(),
            type: actionSetFeatures.type,
        })
    );

    dispatch(actionSetFeatures(data));
};
